import { isDomContentLoaded } from '../../../modules/get_perfomance'
import { getQueryParam } from '../../../modules/get_query'
import { getFeatureUrlString, setUrlMap } from '../../../modules/get_apiUrlString'

export default () => {

  const init = () => {
    setUrlMap(window.pist6);
    const worker = new Worker('/assets/js/data/worker/api_thread.js');
    worker.postMessage({
      url: getFeatureUrlString(getQueryParam('player_id')),
      cb: (cb).toString()
    })
    worker.addEventListener('message', evt => {

      if (evt.data.type == 'error') {
        const pickup = document.querySelector('.at-pickup');
        if (pickup) {
          pickup.closest('.at-body__pickup').innerHTML = "";
        }
        return;
      }

      if (isDomContentLoaded()) {
        buildFeatureContent(evt.data);
      } else {
        window.addEventListener('DOMContentLoaded', () => {
          buildFeatureContent(evt.data);
        })
      }
    })

  }

  const cb = (data) => {
    const featureList = data.api.feature_list.map(feature => {
        feature.date = feature.release_date.replace(/-|\./g, '.');
        feature.lead = feature.lead_sentence.slice(0, 30);
        feature.time = (new Date(feature.release_date)).getTime();
        return feature
      })
      .sort((a, b) => b.time - a.time)
      .splice(0, 3);

    postMessage(featureList);
  }

  const buildFeatureContent = (data) => {
    const isModal = ['', 'true'].includes(getQueryParam('modal'));
    const featureArea = document.querySelector('.at-pickup').parentElement;
    const featureListUl = featureArea.querySelector('.at-pickup__list');
    const featureListitem = featureListUl.firstElementChild;
    const thumbDefaultImgPath = featureListitem.querySelector('.at-pickup__thumb-img').src;
    featureListitem.querySelector('.at-pickup__lead').remove();

    const fragment = document.createDocumentFragment();
    const allImgLoadedPromise = data.map(featureData => {
      return new Promise (resolve => {

        const cloneListitem = featureListitem.cloneNode(true);
        const thumbImg = cloneListitem.querySelector('.at-pickup__thumb-img');

        const pickupLink = cloneListitem.querySelector('.at-pickup__link');
        pickupLink.href = featureData.article_path;
        if (isModal) {
          pickupLink.setAttribute('target', '_blank');
        }
        cloneListitem.querySelector('.at-pickup__name-en').textContent = featureData.player_name_en;
        cloneListitem.querySelector('.at-pickup__name-jp').textContent = featureData.player_name_jp;
        // cloneListitem.querySelector('.at-pickup__lead').textContent = featureData.lead;
        cloneListitem.querySelector('.at-pickup__date').textContent = featureData.date;
        cloneListitem.querySelector('.at-pickup__category').textContent = featureData.category;

        const img = new Image();
        img.classList.add('at-pickup__thumb-img');
        img.alt = featureData.player_name_jp || featureData.player_name_en;
        img.addEventListener('load', () => {
          const thumb = thumbImg.parentElement;
          thumbImg.remove();
          thumb.appendChild(img);
          resolve();
        })
        img.addEventListener('error', () => {
          img.src = thumbDefaultImgPath;
        })
        img.src = featureData.thumbnail_path;

        fragment.appendChild(cloneListitem);
      })
    })

    Promise.all(allImgLoadedPromise)
      .then(() => {
        featureListUl.classList.remove('_skelton');
        featureListUl.removeAttribute('aria-hidden');

        featureListUl.innerHTML = '';
        featureListUl.appendChild(fragment);
      })
  }

  init();
}
